import { axiosInstance } from '../axios';

import { TableResultType } from '@/shared/types/api.type';
import {
  WcItemsCondition,
  GetWcItemsRequest,
  GetIdentityDocumentLocationRequest,
  GetIdentityDocumentLocationResponse,
  GetWorldCheckListRequest,
  WcSearchResultListModel,
  GetDetailWithCustomerRequest,
  WcDetailModel,
} from '@/shared/types/api/api.worldCheck';

export const getWcItems = async ({ groupId }: GetWcItemsRequest): Promise<WcItemsCondition> => {
  const { data } = await axiosInstance.get<WcItemsCondition>(
    `/group/${groupId}/customer/worldCheck/items`,
  );
  return data;
};

export const getIdentityDocumentLocationTypes = async ({
  groupId,
  countryCode,
  entityType,
}: GetIdentityDocumentLocationRequest): Promise<GetIdentityDocumentLocationResponse[]> => {
  const { data } = await axiosInstance.post<GetIdentityDocumentLocationResponse[]>(
    `/group/${groupId}/customer/worldCheck/identityDocumentLocationTypes`,
    {
      countryCode,
      entityType,
    },
  );

  return data;
};

export const getWorldCheckList = async ({
  groupId,
  pageIndex,
  pageSize,
  wcExecutionHistoryId,
  condition,
}: GetWorldCheckListRequest): Promise<TableResultType<WcSearchResultListModel[]>> => {
  const { data } = await axiosInstance.post<TableResultType<WcSearchResultListModel[]>>(
    `/group/${groupId}/execution/${wcExecutionHistoryId}/worldCheck/list`,
    {
      ...condition,
    },
    {
      params: {
        offset: (pageIndex - 1) * pageSize,
        limit: pageSize,
      },
    },
  );
  return data;
};

export const getDetailWithCustomer = async ({
  groupId,
  wcReferenceId,
  wcSearchResultListId,
  executionHistoryId,
}: GetDetailWithCustomerRequest): Promise<WcDetailModel> => {
  const { data } = await axiosInstance.get<WcDetailModel>(
    `/group/${groupId}/execution/${executionHistoryId}/list/${wcSearchResultListId}/detail/worldCheck/${wcReferenceId}`,
  );
  return data;
};
